/* eslint-disable no-debugger */
/* eslint-disable default-param-last */
import { getConstants } from '../actions/actionType';

export function offerList(state = {}, action) {
    switch (action.type) {
    case getConstants.GET_ALL_OFFER_SUCCESS:
        return {
            type: getConstants.GET_ALL_OFFER_SUCCESS,
            offers: action.user.data.data,
            pagination: action.user.data.data.number_of_pages,
        };
    case getConstants.GET_ALL_OFFER_FAILURE:
        return {
            type: getConstants.GET_ALL_OFFER_SUCCESS,
            message: action.message,
        };
    default:
        return state;
    }
}
